import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const getStatsData = async (accessAuthToken: string, clientId, month?: number, year?: number) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/clients/stats/request_stats`;

    const requestBody = {
      client_id: clientId,
      month: month,
      year: year,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error("Failed to get client stats data");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Something went wrong when getting client stats data", error);
    showErrorToast("Something went wrong when getting client stats data");
    throw error;
  }
};
